/** 
 * @module ref/autocdm2 核心功能模块
*/
let obj = require('@/ref/threejs/libs/inflate.min.js');
import global from '@/utils/global';
import { customModelLabel } from "@/ref/custom.js";


//-------------------------------------------------


let Zlib = obj.Zlib;
let compression = {
    inflate: function (blob, callback) {
        let fr = new FileReader();
        fr.readAsArrayBuffer(blob);
        fr.onloadend = function (a) {
            let compressed = fr.result;
            let inflate = new Zlib.Inflate(new Uint8Array(compressed));
            let u8array = inflate.decompress();
            callback(u8array);
        }
    },
    u8arrayToStr: function (u8array, encode, callback) {
        let blob = new Blob([u8array]);
        let fr = new FileReader();
        fr.readAsText(blob, encode);
        fr.onloadend = function (a) {
            let str = fr.result;
            callback(str);
        }
    }
};
//-------------------------------------------------------------------------------------------------------

/** 
 * @type {string}
 *  @description 所有构件在tree transfer等组件上要用到的key
 */
let key = global.meshKey;

/** 
 * @type {string} 
 * @description 构件树要显示的字段
 * 
*/
let label = global.ModelViewTreeLabel;


/**
 *在选中项目后，抓取模型group后调用。从group抽出每个mesh并做一些处理，然后set到state.meshs上
 *
 * @param {group} group 从autoCDM生成的group
 * @param {array} array 要set进去的array
 * @param {object} compInfos 模型的属性数据
 */
function extractMeshs(group, array, compInfos) {
    let tmp = {};
    let tmparray = [];
    group.traverse(function (mesh) {
        if (mesh.type == 'Mesh') {
            mesh = getParent(mesh);
            let k = mesh[key];
            if (!tmp[k]) {
                tmparray.push(mesh);
                wrapMesh(mesh, compInfos);//为Mesh加上key 和 label 字段，给transfer组件用            
                mesh.updateWorldMatrix();
                tmp[k] = k;
            }
        }
    });
    tmparray = customTreeDatas(tmparray);
    for (let i = 0; i < tmparray.length; i++) {
        array.push(tmparray[i]);
    }
};

//--------------------------------------------------------------------------------
function getParentt(mesh, key) {
    let parent = mesh.parent;
    if (parent) {
        if (parent[key] && parent[key].length > 0) {

        } else {
            parent = getParentt(parent);
        }
    }
    return parent;
};
/**
 *
 *取有效的group，当group有mid属性就为有效group，将group当成一个构件，比如复合构件。有些构件是一个group下挂多个mesh，这种要当做一个构件
 * @param {mesh} mesh
 * @param {*} [keyy=key] 可指定，缺省取配置的value
 * @return {group}  有效的group
 */
export function getParent(mesh, keyy = key) {
    let parent = getParentt(mesh, keyy);
    if (!parent) parent = mesh;
    return parent;
}
function wrapMesh(mesh, compInfos) {//为了给transfer组件用
    if (!mesh.key) {
        mesh.key = mesh[key] + "";
    };
    //    
    let showlabel = customModelLabel(mesh, compInfos);
    mesh[label] = mesh[label] ? mesh[label] : showlabel;
    //
    if (!mesh.label) {
        mesh.label = mesh[label] + "";//TODO 换成名称
    }
};
//-------------------------------------------------------------------------------------------------------

/*
 * 定制构件树结点数据。比如在array上调整parentid信息
 * @param {*} array 
 */
function customTreeDatas(array) {
    return array;
};

/**
 *将指定的dom变成全屏
 *
 * @export
 * @param {object} dom 页面dom对象
 */
export function requestFullScreen(dom) {
    var requestMethod =
        dom.requestFullScreen ||
        dom.webkitRequestFullScreen || //谷歌
        dom.mozRequestFullScreen || //火狐
        dom.msRequestFullScreen; //IE11
    if (requestMethod) {
        requestMethod.call(dom); //执行这个请求的方法
    } else if (typeof window.ActiveXObject !== "undefined") {
        //window.ActiveXObject判断是否支持ActiveX控件
        //这里其实就是模拟了按下键盘的F11，使浏览器全屏
        var wscript = new ActiveXObject("WScript.Shell"); //创建ActiveX
        if (wscript !== null) {
            //创建成功
            wscript.SendKeys("{F11}"); //触发f11
        }
    }
};
export { compression, extractMeshs };


// WEBPACK FOOTER //
// ./src/ref/autocdm/threejsUtils.js